import { SEARCH_WIDGET_PLACE_ID } from '../../constants/header';

export const SEARCH_WIDGET_SETTINGS = {
  theme: 'modern',
  place: `#${SEARCH_WIDGET_PLACE_ID}`,
  animated: false,
  expanded: true,
  useLocalStorage: false,
  geoLocation: true,
};
